export default {
  // Endpoints
  registerEndpoint: '/user/register/',
  loginEndpoint: '/user/login/',
  logoutEndpoint: '/user/logout/',

  sendPasswordResetEmailEndpoint: 'user/password/reset/',
  resetPasswordEndpoint: 'user/password/reset/confirm/',

  refreshEndpoint: '/user/token/refresh/',


  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
